export default __webpack_public_path__ + "static/media/marker-full.3ab9e655.png";